import React, { ReactNode, useEffect, useState } from 'react'
import styles from './CommunityHero.module.scss'
import apartmentHeroImage from '../../images/apartment-projects-hero.jpg'
import hoaHeroImage from '../../images/hoa-projects-hero.jpg'
import joinHeroImage from '../../images/join-our-team-hero.jpg'
import heroShape from '../../images/community-page-hero-shape.svg'
import wildCircle from '../../images/wild-circle-2.svg'
import { CommunityType } from '../../lib/types'
import { Image } from '../Image/Image'

export const CommunityHero = (props: {
  type: CommunityType
  children?: ReactNode
}): React.JSX.Element => {
  const [imageHero, setImageHero] = useState<string>()
  const [headline, setHeadline] = useState<string>()
  const [text, setText] = useState<string>()
  /* const [packageUrl, setPackageUrl] = useState<string>(); */

  useEffect(() => {
    if (props.type === 'Apartment') {
      setImageHero(apartmentHeroImage)
      setHeadline('Power your<br>Apartments<br>on Fiber')
      setText('')
    }
    if (props.type === 'HOA') {
      setImageHero(hoaHeroImage)
      setHeadline('Power your<br>HOA with<br>Cityside Fiber')
      setText('')
    }
    if (props.type === 'Join') {
      setImageHero(joinHeroImage)
      setHeadline('We’re just<br>getting started')
      setText('Come join our rapidly growing team in Southern California!')
    }
  }, [props.type])

  return (
    <section
      className={`${styles.hero} ${
        styles['hero__' + props.type.toLowerCase()]
      }`}
    >
      <div className={`${styles.hero_color_square}`}></div>

      <div className={`${styles.hero_shape}`}>
        <img src={heroShape} alt="" />
      </div>

      <div className={`grid-12 ${styles.container}`}>
        <div className={styles.wild_circle}>
          <img src={wildCircle} alt="" />
        </div>
        <div className={styles.content}>
          <div className={styles.headline}>
            {headline && (
              <h1 dangerouslySetInnerHTML={{ __html: headline }}></h1>
            )}

            {text && <p className={styles.text}>{text}</p>}
          </div>
          <div className={styles.image}>
            <Image src={imageHero} alt='residential buildings' loading='eager' />
          </div>
        </div>
      </div>
    </section>
  )
}
